// extracted by mini-css-extract-plugin
export default {"msg_container":"q9","message":"r9","show":"s9","fromRD":"t9","fromCustomer":"u9","note":"v9","loading":"w9","image":"x9","initials":"y9","input_wrapper":"z9","input":"A9"};
    if(module.hot) {
      // 1713969939341
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  